import { render, staticRenderFns } from "./StepFooter.vue?vue&type=template&id=2bbc5a32&scoped=true&"
import script from "./StepFooter.vue?vue&type=script&lang=js&"
export * from "./StepFooter.vue?vue&type=script&lang=js&"
import style0 from "./StepFooter.vue?vue&type=style&index=0&id=2bbc5a32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbc5a32",
  null
  
)

export default component.exports